import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { getAppRoutesArray } from './app-routes';
import { where } from '../framework/utils/collection';
import { ResourceNotFoundPage } from '../pages/not-found';

export const AppPages: React.FunctionComponent = () => {
  const topLevelRoutes = where(getAppRoutesArray(), route => route.topLevel);
  
  return (
    <Switch>
        {topLevelRoutes.map(route => <Route key={route.key} path={route.urlTemplate} exact={route.exact} component={route.component} />)}
        <Route path={'*'} component={ResourceNotFoundPage} />
    </Switch>
  );
};
